// extracted by mini-css-extract-plugin
export default {"Container":"InputNumber_Container__Stmfw","Label":"InputNumber_Label__-1DvX","Error":"InputNumber_Error__OTLWr","ErrorContainer":"InputNumber_ErrorContainer__hqO9J"};